import cartOptions from '@/ui/ui_cart/default-selectors.json';

/**
 * @module getCartItemAccessoriesData
 * @private
 * @description
 * Получение данных по аксессуарам для айтема корзины
 *
 * @param {HTMLElement} cartItemNode - Нода айтема корзины
 *
 * @return {Object} - Данные по аксессуарам
 */
export default (cartItemNode) => {
  const accessoriesData = {};

  if (!cartItemNode) { return accessoriesData; }

  const accessoriesNode = cartItemNode.querySelector(cartOptions.itemAccessories.attr);

  if (accessoriesNode) {
    const accessoryValueNodes = Array.from(accessoriesNode.querySelectorAll(cartOptions.itemAccessoryValueId.attr));

    if (accessoryValueNodes.length) {
      accessoryValueNodes.forEach(accessoryNode => {
        accessoriesData[accessoryNode.dataset.itemAccessoryValueId] = 1;
      });
    }
  }

  return accessoriesData;
};
